// Translation descriptors are the Leaderboard API's text contract: the
// backend never ships translated strings, only {key, params?} pairs whose
// keys live in config/locales/tournaments2/leaderboard/*.yml (shared with
// the cut-line label and the tournament info tooltip).
//
// A param that is itself translatable ships as a nested {key} object and is
// translated before interpolation. A nested key missing from the catalog
// degrades to its humanized last segment ("wheel_pairs" -> "wheel pairs")
// instead of an i18n-js missing marker, since the backend derives entity
// segments from score-scope titles.
const resolveParam = (value) => {
  if (!value || typeof value !== 'object') return value;
  if (!value.key) return '';

  return window.I18n.t(value.key, { defaultValue: value.key.split('.').pop().replace(/_/g, ' ') });
};

// Translates one descriptor; '' without a key or without window.I18n.
export const resolveMessageDescriptor = (descriptor) => {
  if (!descriptor?.key || !window.I18n) return '';

  const params = {};
  Object.entries(descriptor.params || {}).forEach(([name, value]) => {
    params[name] = resolveParam(value);
  });

  return window.I18n.t(descriptor.key, params);
};

// Translates an ordered list of descriptors, dropping the ones that resolve
// to nothing (so callers can test the result's length before rendering).
export const resolveMessageDescriptors = (descriptors) =>
  (Array.isArray(descriptors) ? descriptors : [])
    .map(resolveMessageDescriptor)
    .filter(Boolean);

// A component's own UI text, following the module convention of an English
// fallback wherever window.I18n is absent. `key` is relative to
// leaderboard_v2.components (config/locales/javascript/leaderboard_v2/*.yml);
// interpolation params apply to the translation only - build the fallback
// string yourself.
export const componentText = (key, fallback, params) =>
  (!window.I18n ? fallback : window.I18n.t(`leaderboard_v2.components.${key}`, params));
